import { useAppState } from 'src/state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function SuperAdminTenantBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().tenants
    if (!currentItem) return <span>Tenant</span>;
    return (
        <span>{`${currentItem.name}`}</span>
    );
}